"use client";

import SystemErrorNotifier from "@components/SystemErrorNotifier";
import { CvvProvider } from "@lib/contexts/cvv";
import { debugContext, DebugKey } from "@hudson/ui/lib";
import { useState } from "react";
import AppsignalProvider from "./AppsignalProvider";
import { ApolloProvider } from "@hudson/ui/graphql";
import { useFrameConfig } from "@lib/hooks/useFrameConfig";
import { getAuthToken } from "@lib/graphql/getAuthToken";
import { getServiceAreaId } from "@lib/graphql/getServiceAreaId";
import { getHostPageParentUrl } from "@lib/graphql/getHostPageParentUrl";
import FrameConfigProvider from "./FrameConfigProvider";

export default function Providers({
  children,
  siteId,
}: {
  children: React.ReactNode;
  siteId: string;
}) {
  const [debugMode, setDebugMode] = useState(false);
  const { bridgeId, bridgeType, language, override, jsonHeaders } = useFrameConfig();

  return (
    <AppsignalProvider siteId={siteId}>
      <debugContext.Provider value={{ debugMode, setDebugMode }}>
        <DebugKey>
          <CvvProvider>
            <SystemErrorNotifier>
              {(showError: (message: string) => void) => (
                <ApolloProvider
                  showError={showError}
                  siteId={siteId}
                  bridgeId={bridgeId}
                  bridgeType={bridgeType}
                  language={language}
                  override={override}
                  jsonHeaders={jsonHeaders}
                  getAuthToken={getAuthToken}
                  getServiceAreaId={getServiceAreaId}
                  getHostPageParentUrl={getHostPageParentUrl}
                >
                  <FrameConfigProvider>{children}</FrameConfigProvider>
                </ApolloProvider>
              )}
            </SystemErrorNotifier>
          </CvvProvider>
        </DebugKey>
      </debugContext.Provider>
    </AppsignalProvider>
  );
}
